import api from '@/utils/api'

export default {
    createCoach(data) {
        return api.post(`coaches`, data)
    },
    getCoach(coachId) {
        return api.get(`coaches/${coachId}`)
    },
    getCoaches(params) {
        return api.get(`coaches`, { params })
    },
    updateCoach(coachId, data) {
        return api.put(`coaches/${coachId}`, data)
    },
    getFilteredCoaches(filters, page, size) {
        const params = { ...filters, page, size }
        return api.get(`coaches`, { params })
    }
}
